// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import createSearchParams from '../../helpers/createSearchParams'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import generateReportQuery from '../../helpers/generateReportQuery'
import { reportPermissions, accountPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
// const baseUrl = 'https://sandbox-reporting.udara360.io/api'

export default {
  getOverdraftReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/overdraftReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.OVERDRAFT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTransactionReports: async (context, {
    search, page = 1, limit = 10, route, permission, type = '', entryCodes,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    let codes
    if (entryCodes) {
      codes = entryCodes.map(item => (`entryCodes=${item}`)).join('&')
    }

    const transactionURL = type === 'entryCode' ? `${url}&${codes}` : url
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${transactionURL}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadTransactionReports: async (context, {
    search, page = 1, limit = 10, route, permission,
  }) => {
    const url = generateReportQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEODTransactionReports: async (context, {
    search, page = 1, limit = 10, route, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountBalances: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/customerAccountBalanceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAdvances: async (context, { search, page = 1, limit = 20 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loansAndAdvances',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_AND_ADVANCES_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanAdvances: async (context, {
    search, page = 1, limit = 20, fileExportFormat,
  }) => {
    const url = generateReportQuery({
      filter: search,
      url: 'LoanReports/v1/exportLoansAndAdvances',
      currentPage: page,
      perPage: limit,
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(reportPermissions.EXPORT_LOANS_AND_ADVANCES_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanCollections: async (context, {
    search, page = 1, limit = 20, fileExportFormat,
  }) => {
    const url = generateReportQuery({
      filter: search,
      url: 'LoanReports/v1/exportLoansCollections',
      currentPage: page,
      perPage: limit,
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(reportPermissions.EXPORT_LOAN_COLLECTIONS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanTrackingReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanTracking',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_TRACKING_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getClosedLoanReport: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/closedLoans',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEChannelTransactionReport: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/echannelsReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getActiveAccountReport: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/activeAccountsReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VIEW_ACTIVE_ACCOUNTS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountBalanceMovement: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/accountBalanceMovementReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_BALANCE_MOVEMENT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanCollections: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanCollections',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_COLLECTIONS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDepositBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/depositBalanceReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DEPOSITS_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getVatWHTReports: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/getVATandWHTReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VAT_AND_WHT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFixedDepositBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/fixedDepositBalanceReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.FIXED_DEPOSITS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBVNNINComplianceReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'RegulatoryReports/v1/complianceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VIEW_COMPLIANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDailyTillBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/getDailyTillBalanceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DAILY_TILL_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSavingsAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/savingsAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.SAVINGS_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/loanAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFDAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/fdAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraftAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/odAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.OVERDRAFT_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLHistories: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/glHistoryReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.GL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLBalanceHistories: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/glStatement',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.GL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanRepaymentExpectation: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanExpectation',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_REPAYMENT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDisbursedLoansReports: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/disbursedLoans',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DISBURSED_LOAN_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChartOfAccount: async () => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_CHART_OF_ACCOUNT_REPORT)
      const response = await axiosIns.get('/reporting/api/FinancialReports/v1/chartofaccount')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTrialBalance: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/trialbalance?FinancialDate=${formData.financialDate}&BranchCode=${formData.branchCode}&Level=${formData.level}&IsCurrentFinancialDate=${formData.isCurrentFinancialDate}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadTrialBalanceReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/exportTrialBalanceReport?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadNDICReport: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_NDIC_REPORT)
      const response = await axiosIns.get(`/reporting/api/NdicReport/v1/getNdicReport?ReportingDate=${formData.reportingDate}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCBNReport: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_CBN_REPORT)
      const response = await axiosIns.get(`/reporting/api/CBNReport/v1/getCBNReport?ReportingDate=${formData.reportingDate}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadActiveAccountReport: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.EXPORT_ACTIVE_ACCOUNTS_REPORT)
      const response = await axiosIns.get(`/reporting/api/CustomerAccountReports/v1/exportActiveAccountReport?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadEChannelTransactionReport: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.EXPORT_ECHANNEL_REPORT)
      const response = await axiosIns.get(`/reporting/api/TransactionReports/v1/exportEchannelsReport?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBalanceSheetReport: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.VIEW_BALANCE_SHEET_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/balanceSheetReport?${searchParams}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadBalanceSheetReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_BALANCE_SHEET_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/exportBalanceSheetReport?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadProfitAndLossReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_PROFIT_OR_LOSS_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/exportprofitOrLossReport?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProfitOrLoss: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.VIEW_PROFIT_OR_LOSS_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/profitOrLossReport?${searchParams}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPeriodicTrialBalance: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/FinancialReports/v1/periodictrialbalance?StartDate=${formData.startDate}&EndDate=${formData.endDate}&BranchCode=${formData.branchCode}&Level=${formData.level}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerAccountStatement: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.ACCOUNT_STATEMENT)
      const response = await axiosIns.get(`/reporting/api/CustomerStatement/v1/generateStatement?FinancialDateFrom=${formData.financialDateFrom}&FinancialDateTo=${formData.financialDateTo}&AccountNumber=${formData.accountNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCustomerAccountStatementReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(accountPermissions.ACCOUNT_STATEMENT)
      const response = await axiosIns.get(`/reporting/api/CustomerStatement/v1/exportCustomerStatement?${searchParams}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getICADReport: async (context, { search, page, limit }) => {
    try {
      useJwt.setPermission(reportPermissions.ICAD_REPORT)
      const response = await axiosIns.get(`/reporting/api/RegulatoryReports/v1/icadReport?StartDate=${search.startDate}&EndDate=${search.endDate}&PageNumber=${page}&PageSize=${limit}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadICADReport: async (context, {
    search, page = 1, limit = 20, fileExportFormat,
  }) => {
    const url = generateReportQuery({
      filter: search,
      url: 'RegulatoryReports/v1/exporticadReport',
      currentPage: page,
      perPage: limit,
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(reportPermissions.EXPORT_ICAD_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCreditBrueau: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_CREDIT_BUREAU_REPORT)
      const response = await axiosIns.get(`/reporting/api/RegulatoryReports/v1/exportCreditBureau?ReportingDate=${formData.reportingDate}&PeriodTogenerateHistoryInMonths=${formData.period}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNFIUReport: async (context, {
    search, page = 1, limit = 10,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'RegulatoryReports/v1/nfiuReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.NFIU_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNewlyCreatedAccountReport: async (context, {
    search, page = 1, limit = 10,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/accountCreationReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_CREATION_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSuspiciousTransactionReports: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/SearchSuspiciousTransactions',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBatchUploadTracer: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/SearchBatchJobsReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanApplicationLetter: async (context, { partnerCode, permission, route }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/LMS/v1/${route}?PartnerCode=${partnerCode}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadKYCDocumentFiles: async (context, { partnerCode, permission, route }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/LMS/v1/${route}?PartnerCode=${partnerCode}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  exportSMSReports: async (context, { fileExportFormat, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/SMSReport/v1/exportSmsReport?FileExportFormat=${fileExportFormat}`, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
